<form novalidate
  [formGroup]="_form"
  (keydown.enter)="$event.preventDefault()"
  class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
        </div>
        <div class="transaction-section-header-actions header-actions">
          @if (_cycleCountGridData.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_process()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
              </span>Process
            </button>
          }
          @if (_cycleCountGridData.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_save()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" />
              </span>Save Draft
            </button>
          }
          @if (_cycleCountGridData.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_print()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
              </span>Print
            </button>
          }
          @if (_cycleCountGridData.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_export()">
              <span>
                <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
              </span>Export PDF
            </button>
          }
          <button class="hidden-xs asap-btn" kendoButton (click)="_reset()">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" />
            </span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row no-row-margin">
    <!-- Step 1: Configuration -->
    <div class="col-12 col-lg-6 small-pad-right">
      <div class="transactionWidget">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="titleStandardStyle mb-0">Step 1: Configuration</p>
              <div class="d-flex align-items-center">
                <span class="mr-2 font-weight-bold" style="font-size: 13px;">Progress:</span>
                <span class="badge badge-primary px-2 py-1" style="font-size: 13px; border-radius: 6px;">
                  {{_totalPercentage}}%
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Date - Time</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker class="k-datepicker datepickerControlrightMargin"
                    [disabled]="!_dateEnabled || _cycleCountGridData.length > 0"
                    formControlName="transactionDate"
                    placeholder="Set Date and Time"
                    [format]="_datePickerFormat"
                    (valueChange)="_startDateSubmited()"
                    (open)="_startDateOpened()">
                  </kendo-datetimepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Count By</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center mr-4">
                      <kendo-radiobutton #stockItemBtn
                        [value]="1"
                        [disabled]="_cycleCountGridData.length > 0"
                        formControlName="countType">
                      </kendo-radiobutton>
                      <kendo-label class="k-radio-label ml-2 mb-0"
                        [for]="stockItemBtn"
                        text="Stock Items *">
                      </kendo-label>
                    </div>
                    <div class="d-flex align-items-center">
                      <kendo-radiobutton #locationRadioBtn
                        [value]="2"
                        [disabled]="_cycleCountGridData.length > 0"
                        formControlName="countType">
                      </kendo-radiobutton>
                      <kendo-label class="k-radio-label ml-2 mb-0"
                        [for]="locationRadioBtn"
                        text="Locations **">
                      </kendo-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Sample %</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-numerictextbox [step]="0.05"
                    format="p0"
                    [min]="0.01"
                    [max]="_maxChunkPercentage"
                    [disabled]="_cycleCountGridData.length > 0"
                    formControlName="percentage"
                    (change)="percentageChange($event)">
                  </kendo-numerictextbox>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mt-3">
            <hr>
              <small class="text-muted d-block mb-1">* Samples randomly across active inventory items.</small>
              <small class="text-muted d-block">** Samples locations and counts all stock inside them.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Start / Count Session -->
      <div class="col-12 col-lg-6 small-pad-left">
        <div class="transactionWidget"
          (click)="_listboxClicked()"
          [class.active]="_addClassActiveLocation">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <p class="titleStandardStyle mb-0">Step 2: Start Count Session</p>
                @if (_cycleCountGridData.length > 0) {
                  <div class="d-flex align-items-center">
                    <span class="badge badge-info px-2 py-1 mr-2" style="font-size: 13px; border-radius: 6px;">
                      Items: {{_cycleCountGridData.length}}
                    </span>
                    <span class="badge badge-secondary px-2 py-1" style="font-size: 13px; border-radius: 6px;">
                      Sample: {{_processPercentage}}%
                    </span>
                  </div>
                }
              </div>
            </div>

            @if (_cycleCountGridData.length === 0) {
              <div class="col-12 margin-top-10">
                @if (_totalPercentage >= 100 || _maxChunkPercentage <= 0) {
                  <div class="alert alert-info py-2 px-3 mb-2" style="font-size: 13px; border-radius: 6px;">
                    <strong>Count Completed (100%):</strong> All items for this transaction have been counted. Please navigate to <strong>Cycle Count Adjust</strong> to review variances and finalize the transaction.
                  </div>
                }
                @if (_totalPercentage < 100 && _maxChunkPercentage > 0) {
                  <p class="text-muted mb-3" style="font-size: 13px;">
                    Select configuration options in Step 1, then click below to generate sampled stock items.
                  </p>
                }
                @if (_totalPercentage < 100 && _maxChunkPercentage > 0) {
                  <button kendoButton
                    class="asap-btn"
                    [disabled]="_isDrafted || _totalPercentage >= 100 || _maxChunkPercentage <= 0"
                    (click)="_startCycleCount()"
                    >
                    Start Cycle Count
                  </button>
                }
              </div>
            }

            @if (_cycleCountGridData.length > 0) {
              <div class="col-12 margin-top-10">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <label class="control-label">Session Name</label>
                    </div>
                    <div class="col-10 transaction-input-fields">
                      <input type="text"
                        class="k-textbox writebox"
                        formControlName="cycleName"
                        placeholder="Enter Cycle Count Session Name" />
                      </div>
                    </div>
                  </div>
                  @if (_isDrafted) {
                    <div class="form-group special_style_formgroup margin-top-10">
                      <div class="row">
                        <div class="col-2">
                          <label class="control-label">Status</label>
                        </div>
                        <div class="col-10 transaction-input-fields d-flex align-items-center">
                          <span class="badge badge-warning px-2 py-1" style="font-size: 12px; border-radius: 6px;">
                            Drafted Session
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Validation Summary -->
        @if (_invalidForm) {
          <div class="row w-100 mx-0">
            <div class="col-12">
              <asap-forms-validation-summary [form]="_form" [page]="page">
              </asap-forms-validation-summary>
            </div>
          </div>
        }

        <!-- Count Data Grid -->
        @if (_cycleCountGridData.length > 0) {
          <div class="col-12 mt-3">
            <div class="asap-section-container with-grid"
              (click)="_gridclicked()"
              [class.active]="_addClassActiveGrid">
              <div class="row zeromarginRow align-items-center mb-2 px-3 pt-3">
                <div class="col-12">
                  <p class="titleStandardStyle mb-0">
                    <span>Items Counted: </span>
                    <span class="autoGenerateSection">
                      <strong>{{_cycleCountGridData.length}}</strong>
                    </span>
                  </p>
                </div>
              </div>
              <div #gridWrapper>
                <kendo-grid [data]="_cycleCountGridData"
                  #grid
                  [resizable]="true"
                  class="asap-standalone-grid">
                  <kendo-grid-column field="stockItemCode" title="Item Code" [width]="160">
                  </kendo-grid-column>
                  <kendo-grid-column field="stockItemDescription" title="Description" [width]="220">
                  </kendo-grid-column>
                  <kendo-grid-column field="inventoryNumber" title="Inventory #" [width]="150">
                  </kendo-grid-column>
                  <kendo-grid-column field="expectedLocationName" title="Expected Location" [width]="170">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.expectedLocationName || dataItem.expectedLocationCode || ''}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="actualLocationName" title="Actual Location" [width]="200">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <kendo-combobox [data]="dataItem.locationsFiltered || _locations"
                        [suggest]="true"
                        [filterable]="true"
                        (filterChange)="onLocationFilterChange($event, dataItem)"
                        [textField]="'code'"
                        [valueField]="'id'"
                        [value]="getSelectedLocation(dataItem)"
                        (valueChange)="onLocationChange($event, dataItem)"
                        (open)="dataItem.locationsFiltered = _locations"
                        [placeholder]="'Select Location'"
                        class="w-100 bordered">
                      </kendo-combobox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="expectedQuantity" title="Expected Qty" [width]="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{dataItem.expectedQuantity | number:'1.0-2'}}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="actualQuantity" title="Actual Qty" [width]="140">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <kendo-numerictextbox [value]="dataItem.actualQuantity"
                        [min]="0"
                        [step]="1"
                        [autoCorrect]="true"
                        (valueChange)="onActualQuantityChange(dataItem, $event)"
                        class="k-textbox writebox smallNumeric w-100">
                      </kendo-numerictextbox>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="varianceQuantity" title="Variance" [width]="110">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span [class.text-danger]="dataItem.variance" [class.text-success]="!dataItem.variance" class="font-weight-bold">
                        {{(dataItem.actualQuantity - dataItem.expectedQuantity) | number:'1.0-2'}}
                      </span>
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-pdf [fileName]="_exportFileName + '.pdf'"
                    paperSize="A4"
                    [allPages]="true"
                    [repeatHeaders]="true"
                    [landscape]="true"
                    [scale]="0.5">
                    <kendo-grid-pdf-margin top="2cm"
                      left="1cm"
                      right="1cm"
                      bottom="2cm">
                    </kendo-grid-pdf-margin>
                    @for (item of _pdfColumns; track item) {
                      <kendo-grid-column
                        [title]="item.name"
                        [field]="item.field"
                        [width]="item.width">
                      </kendo-grid-column>
                    }
                  </kendo-grid-pdf>
                </kendo-grid>
              </div>
            </div>
          </div>
        }
      </div>
    </form>
